import { render } from "./ExpensesChart.vue?vue&type=template&id=445508b7&scoped=true"
import script from "./ExpensesChart.vue?vue&type=script&lang=js"
export * from "./ExpensesChart.vue?vue&type=script&lang=js"

import "./ExpensesChart.vue?vue&type=style&index=0&id=445508b7&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445508b7"]])

export default __exports__